import { __rest } from "tslib";
import React from 'react';
import BaseCheckBoxSet from '@/components/controls/checkbox-set';
import { wrapControl } from '.';
const CheckBoxSet = wrapControl('checkbox-set')(function CheckBoxSet(_a) {
    var { input, meta: _ } = _a, props = __rest(_a, ["input", "meta"]);
    return <BaseCheckBoxSet selected={input.value} onChange={input.onChange} {...props}/>;
});
export default CheckBoxSet;
